import { wait } from '../async';

export async function maybeYieldToMain(shouldYield = true): Promise<void> {
  if (!shouldYield) {
    return;
  } else if (globalThis.scheduler?.yield) {
    await globalThis.scheduler.yield();
  } else {
    await wait(0);
  }
}
